// extracted by mini-css-extract-plugin
export default {"shortSection":"styles-module--short-section--c9925"};